"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Leadership() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const team = [{
    name: "Marcus Thorne",
    role: "Managing Director \u00B7 MetPro Partners",
    bio: "Twenty-five years of industrial sales leadership, specializing in high-stakes automotive supply chain integration and OEM procurement strategies.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_marcus_thorne.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_marcus_thorne.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_marcus_thorne.webp-wvc-sizes"
  }, {
    name: "Elena Vance",
    role: "Director of Operations \u00B7 MetPro Partners",
    bio: "Two decades optimizing sales workflows for metal fabrication firms, ensuring seamless communication between technical engineering and procurement teams.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_elena_vance.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_elena_vance.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_elena_vance.png-wvc-sizes"
  }, {
    name: "Julian Halloway",
    role: "Technical Sales Lead \u00B7 MetPro Partners",
    bio: "Eighteen years in industrial safety and shipbuilding, bridging the gap between complex technical specifications and market-ready sales solutions.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_julian_halloway.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_julian_halloway.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_julian_halloway.png-wvc-sizes"
  }, {
    name: "Sarah Jenkins",
    role: "Strategic Accounts Manager \u00B7 MetPro Partners",
    bio: "Twenty-two years managing multi-vendor sales efforts, focused on long-term partnership growth and industrial market penetration.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_sarah_jenkins.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_sarah_jenkins.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_sarah_jenkins.png-wvc-sizes"
  }, {
    name: "David Chen",
    role: "Market Intelligence Lead \u00B7 MetPro Partners",
    bio: "Nineteen years analyzing industrial trends and competitive landscapes to drive data-backed sales initiatives for our manufacturing partners.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_david_chen.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_david_chen.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_david_chen.png-wvc-sizes"
  }, {
    name: "Robert Sterling",
    role: "Business Development Director \u00B7 MetPro Partners",
    bio: "Two decades of experience in heavy industry sales, architecting robust outreach programs that deliver consistent results for our clients.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_robert_sterling.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_robert_sterling.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/team_robert_sterling.webp-wvc-sizes"
  }];
  return;
}
function TeamCard({
  index,
  name,
  role,
  bio,
  image,
  srcset,
  sizes,
  ...rest
}: {
  index: number;
  name: string;
  role: string;
  bio: string;
  image: string;
  srcset: string;
  sizes: string;
  [key: string]: unknown;
}) {
  const reveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.18
  });
  return <div ref={reveal.ref} className={`group flex flex-col transition-all ease-out ${reveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`} style={{
    transitionDuration: "620ms",
    transitionDelay: `${index * 80}ms`,
    transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
  }} {...rest}>
      <div className="relative w-full overflow-hidden border border-border" style={{
      aspectRatio: "4 / 5"
    }}>
        <img src={image} data-wvc-srcset={srcset} data-wvc-sizes={sizes} alt={name} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[480ms] ease-out group-hover:scale-[1.03]" />
      </div>

      <div className="mt-6">
        <h3 className="font-default text-[1.0625rem] font-semibold leading-[1.3] tracking-tight text-foreground">
          <span className="bg-[length:100%_1px] bg-bottom bg-no-repeat bg-[image:linear-gradient(transparent,transparent)] transition-[background-image] duration-200 ease-out group-hover:bg-[image:linear-gradient(var(--accent),var(--accent))]" style={{
          paddingBottom: "4px"
        }}>
            {name}
          </span>
        </h3>
        <p className="font-sans mt-1 text-sm font-medium leading-[1.45] tracking-[0.01em] text-muted-foreground">
          {role}
        </p>
        <div className="mt-4 h-px w-12 bg-accent" />
        <p className="font-sans mt-4 text-base font-normal leading-[1.6] text-foreground/85">
          {bio}
        </p>
      </div>
    </div>;
}